__turbopack_context__.v({
  "numberGray": "NumberedHeader-module-scss-module__PxlS9W__numberGray",
  "numberRed": "NumberedHeader-module-scss-module__PxlS9W__numberRed",
});
